import { createContext } from 'react';

const AppContext = createContext<[boolean, (isOpened: boolean) => void]>([false, () => { }]);

export default AppContext;